import {get, post, put, retire} from "$lib/api";

export const getTariffs = async () => await get('/tariffs')

export const postTariff = async (tariff:any) => await post('/tariff', tariff)
export const updateTariff = async (tariff:any) => await put('/tariff/' + tariff.id, tariff)

export const retireTariff = async (tariff:any) => await retire('/tariff/' + tariff.id)